// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { UserView } from "../../user/v1/user";
import { UserExpandMask } from "../../user/v1/user";
import { User } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnersRequest
 */
export interface ListAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 5;
     */
    resourceTypeId: string;
}
/**
 * The ListAppResourceOwnersResponse message contains a list of results and a nextPageToken if applicable
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnersResponse
 */
export interface ListAppResourceOwnersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * User IDs of owners that are immutable and cannot be removed by the user.
     * These owners are managed by the system (e.g., connector-sourced) and will be updated automatically.
     *
     * @generated from protobuf field: repeated string immutable_user_ids = 3;
     */
    immutableUserIds: string[];
}
/**
 * The request message for listing app resource owner IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnerIDsRequest
 */
export interface ListAppResourceOwnerIDsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
}
/**
 * The response message for listing app resource owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnerIDsResponse
 */
export interface ListAppResourceOwnerIDsResponse {
    /**
     * The list of owner IDs for the app resource.
     *
     * @generated from protobuf field: repeated string user_ids = 1;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SetAppResourceOwnersRequest
 */
export interface SetAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 4;
     */
    userIds: string[];
}
/**
 * The empty response message for setting the app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppResourceOwnersResponse
 */
export interface SetAppResourceOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAppResourceOwnerRequest
 */
export interface AddAppResourceOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAppResourceOwnerResponse
 */
export interface AddAppResourceOwnerResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAppResourceOwnerRequest
 */
export interface RemoveAppResourceOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAppResourceOwnerResponse
 */
export interface RemoveAppResourceOwnerResponse {
}
/**
 * The request message for deleting app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResourceOwnersRequest
 */
export interface DeleteAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3;
     */
    resourceTypeId: string;
}
/**
 * the empty response message for deleting app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResourceOwnersResponse
 */
export interface DeleteAppResourceOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceOwnerRef
 */
export interface AppResourceOwnerRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceOwnerRefreshRef
 */
export interface AppResourceOwnerRefreshRef {
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceOwnersRequest
 */
export interface SearchAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 5;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceOwnerRef refs = 6;
     */
    refs: AppResourceOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 7;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceOwnersResponse
 */
export interface SearchAppResourceOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnersRequest$Type extends MessageType<ListAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnersRequest
 */
export const ListAppResourceOwnersRequest = new ListAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnersResponse$Type extends MessageType<ListAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "immutable_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnersResponse
 */
export const ListAppResourceOwnersResponse = new ListAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnerIDsRequest$Type extends MessageType<ListAppResourceOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnerIDsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnerIDsRequest
 */
export const ListAppResourceOwnerIDsRequest = new ListAppResourceOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnerIDsResponse$Type extends MessageType<ListAppResourceOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnerIDsResponse
 */
export const ListAppResourceOwnerIDsResponse = new ListAppResourceOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppResourceOwnersRequest$Type extends MessageType<SetAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppResourceOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Resource_Owner" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppResourceOwnersRequest
 */
export const SetAppResourceOwnersRequest = new SetAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppResourceOwnersResponse$Type extends MessageType<SetAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppResourceOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppResourceOwnersResponse
 */
export const SetAppResourceOwnersResponse = new SetAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppResourceOwnerRequest$Type extends MessageType<AddAppResourceOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppResourceOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppResourceOwnerRequest
 */
export const AddAppResourceOwnerRequest = new AddAppResourceOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppResourceOwnerResponse$Type extends MessageType<AddAppResourceOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppResourceOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppResourceOwnerResponse
 */
export const AddAppResourceOwnerResponse = new AddAppResourceOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppResourceOwnerRequest$Type extends MessageType<RemoveAppResourceOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppResourceOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppResourceOwnerRequest
 */
export const RemoveAppResourceOwnerRequest = new RemoveAppResourceOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppResourceOwnerResponse$Type extends MessageType<RemoveAppResourceOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppResourceOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppResourceOwnerResponse
 */
export const RemoveAppResourceOwnerResponse = new RemoveAppResourceOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResourceOwnersRequest$Type extends MessageType<DeleteAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResourceOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResourceOwnersRequest
 */
export const DeleteAppResourceOwnersRequest = new DeleteAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResourceOwnersResponse$Type extends MessageType<DeleteAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResourceOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResourceOwnersResponse
 */
export const DeleteAppResourceOwnersResponse = new DeleteAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceOwnerRef$Type extends MessageType<AppResourceOwnerRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceOwnerRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceOwnerRef
 */
export const AppResourceOwnerRef = new AppResourceOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceOwnerRefreshRef$Type extends MessageType<AppResourceOwnerRefreshRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceOwnerRefreshRef", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceOwnerRefreshRef
 */
export const AppResourceOwnerRefreshRef = new AppResourceOwnerRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceOwnersRequest$Type extends MessageType<SearchAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceOwnerRef },
            { no: 7, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceOwnersRequest
 */
export const SearchAppResourceOwnersRequest = new SearchAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceOwnersResponse$Type extends MessageType<SearchAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceOwnersResponse
 */
export const SearchAppResourceOwnersResponse = new SearchAppResourceOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceOwners
 */
export const AppResourceOwners = new ServiceType("c1.api.app.v1.AppResourceOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppResourceOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Resource Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppResourceOwnersRequest, O: ListAppResourceOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Resource_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Resource Owner" }] } }, I: ListAppResourceOwnerIDsRequest, O: ListAppResourceOwnerIDsResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Resource_Owner" }], group: "App Resource Owner" }] } }, I: SetAppResourceOwnersRequest, O: SetAppResourceOwnersResponse },
    { name: "Add", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", group: "App Resource Owner" }] } }, I: AddAppResourceOwnerRequest, O: AddAppResourceOwnerResponse },
    { name: "Remove", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", group: "App Resource Owner" }] } }, I: RemoveAppResourceOwnerRequest, O: RemoveAppResourceOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Resource_Owner" }], group: "App Resource Owner" }] } }, I: DeleteAppResourceOwnersRequest, O: DeleteAppResourceOwnersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceOwnersSearch
 */
export const AppResourceOwnersSearch = new ServiceType("c1.api.app.v1.AppResourceOwnersSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceOwnersRequest, O: SearchAppResourceOwnersResponse }
]);
